import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import {
  applyColorSchemeClass,
  COLOR_SCHEME_STORAGE_KEY,
  type ColorScheme,
  readStoredColorScheme,
} from '@/constants/colorSchemeStorage';

export const useUiStore = defineStore('ui', () => {
  const language = ref('en');
  const sidebarOpen = ref(false);
  const colorScheme = ref<ColorScheme>(readStoredColorScheme());

  const isDark = computed(() => colorScheme.value === 'dark');

  function toggleSidebar (): void {
    sidebarOpen.value = !sidebarOpen.value;
  }

  function closeSidebar (): void {
    sidebarOpen.value = false;
  }

  function openSidebar (): void {
    sidebarOpen.value = true;
  }

  function setColorScheme (scheme: ColorScheme): void {
    colorScheme.value = scheme;
    applyColorSchemeClass(scheme);
    try {
      localStorage.setItem(COLOR_SCHEME_STORAGE_KEY, scheme);
    } catch {
      /* private mode */
    }
  }

  function toggleColorScheme (): void {
    setColorScheme(colorScheme.value === 'dark' ? 'light' : 'dark');
  }

  /** Sync Pinia with `document.documentElement` (and inline `index.html` boot script). */
  function initColorScheme (): void {
    const scheme = readStoredColorScheme();
    colorScheme.value = scheme;
    applyColorSchemeClass(scheme);
  }

  return {
    language,
    sidebarOpen,
    colorScheme,
    isDark,
    toggleSidebar,
    closeSidebar,
    openSidebar,
    setColorScheme,
    toggleColorScheme,
    initColorScheme,
  };
});
